import React from 'react';
import { AUTH_BUTTONS } from '../constants';
import { ROUTES } from 'constants.js';
import PropTypes from 'prop-types';
import './style.scss';

const Index = ({ history, login, handleAuth }) => {
    return (
        <div className='container-auth-options'>
            {AUTH_BUTTONS.map((button) => {
                return (
                    <button className='auth-button' key={button.type} onClick={() => handleAuth(button.type)}>
                        <img src={require(`Assets/images/${button.icon}`)} alt='auth-type' />
                        {`${login ? 'Sign in' : 'Sign up'} with ${button.name}`}
                    </button>
                );
            })}
            <div className='account-text'>
                {login ? 'Don’t have an account?' : 'Have an account?'}&nbsp;{''}
                <button className='button-login' onClick={() => history.push(login ? ROUTES.SIGNUP : ROUTES.LOGIN)}>
                    {login ? 'Sign up' : 'Log in'}
                </button>
            </div>
        </div>
    );
};

Index.propTypes = {
    history: PropTypes.object,
    login: PropTypes.bool,
    handleAuth: PropTypes.func,
};

export default Index;
